import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";

const Faq = () => {
  const faqQuestions = [
    {
      question: "What could possibly be your first question?",
      answer:
        "Lorem ipsum, dolor sit amet consectetur adipisicing elit. Maiores impedit perferendis suscipit eaque, iste dolor cupiditate blanditiis ratione. Lorem ipsum, dolor sit amet consectetur adipisicing elit.",
    },
    {
      question: "How does our product work?",
      answer:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam.",
    },
    {
      question: "What is the return policy?",
      answer:
        "Sed nisi. Nulla quis sem at nibh elementum imperdiet. Duis sagittis ipsum. Praesent mauris.",
    },
    {
      question: "How do I contact customer support?",
      answer:
        "Fusce nec tellus sed augue semper porta. Mauris massa. Vestibulum lacinia arcu eget nulla.",
    },
    {
      question: "Can I track my order?",
      answer:
        "Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos.",
    },
    {
      question: "What payment methods are accepted?",
      answer:
        "Curabitur sodales ligula in libero. Sed dignissim lacinia nunc. Curabitur tortor. Pellentesque nibh.",
    },
    {
      question: "How do I update my account information?",
      answer:
        "Aenean quam. In scelerisque sem at dolor. Maecenas mattis. Sed convallis tristique sem.",
    },
    {
      question: "What are the shipping options?",
      answer:
        "Proin ut ligula vel nunc egestas porttitor. Morbi lectus risus, iaculis vel, suscipit quis, luctus non, massa.",
    },
  ];

  return (
    <div>
      <div className="py-4 bg-white">
        <div className="max-w-screen-md mx-auto px-4 sm:px-6 lg:px-8 flex flex-col justify-between">
          <div className="text-center">
            <p className="mt-4 text-sm leading-7 text-gray-500 font-regular">
              F.A.Q
            </p>
            <h3 className="text-3xl sm:text-4xl leading-normal font-extrabold tracking-tight text-gray-900">
              Frequently Asked <span className="text-primary">Questions</span>
            </h3>
          </div>

          <div className="mt-20">
            <ul>
              {faqQuestions.map((faq, index) => (
                <li key={index} className="text-left mb-10">
                  <div className="flex flex-row items-start mb-5">
                    <div className="hidden sm:flex items-center justify-center p-3 mr-3 rounded-full bg-secondary text-white border-4 border-white text-xl font-semibold">
                      <svg
                        width="30px"
                        fill="white"
                        height="30px"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g data-name="Layer 2">
                          <g data-name="menu-arrow">
                            <rect
                              width="24"
                              height="24"
                              transform="rotate(180 12 12)"
                              opacity="0"
                            ></rect>
                            <path d="M17 9A5 5 0 0 0 7 9a1 1 0 0 0 2 0 3 3 0 1 1 3 3 1 1 0 0 0-1 1v2a1 1 0 0 0 2 0v-1.1A5 5 0 0 0 17 9z"></path>
                            <circle cx="12" cy="19" r="1"></circle>
                          </g>
                        </g>
                      </svg>
                    </div>
                    <div className="bg-gray-100 p-5 px-10 w-full flex items-center">
                      <h4 className="text-xl leading-6 font-medium text-gray-900">
                        {faq.question}
                      </h4>
                    </div>
                  </div>

                  <div className="flex flex-row items-start">
                    <div className="bg-indigo-100 p-5 px-10 w-full flex items-center">
                      <p className="text-gray-700 text-l">{faq.answer}</p>
                    </div>
                    <div className="hidden sm:flex items-center justify-center p-3 ml-3 rounded-full bg-primary text-white border-4 border-white text-xl font-semibold">
                      <svg
                        height="25px"
                        fill="white"
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                        x="0px"
                        y="0px"
                        viewBox="0 0 295.238 295.238"
                        style={{ enableBackground: "new 0 0 295.238 295.238" }}
                        xmlSpace="preserve"
                      >
                        <g>
                          <g>
                            <g>
                              <path d="M277.462,0.09l-27.681,20.72l-27.838,64.905h-22.386l-8.79-19.048h5.743c10.505,0,19.048-8.452,19.048-18.957V28.571 h9.524V0H196.51v28.571h9.524V47.71c0,5.248-4.271,9.433-9.524,9.433h-10.138L174.2,30.81l14.581-7.267L141.038,3.095 l-11.224,39.281c-0.305-23.371-19.386-42.29-42.829-42.29c-23.633,0-42.857,19.224-42.857,42.857 c0,14.281,7.233,27.676,19.048,35.595v7.176H51.643L50.9,89.619c-2.314,12.005-2.529,24.343-0.638,36.648l-32.486,57.905 l35.876,8.195v60.014h47.619v42.857h114.286v-66.357c33.333-23.581,52.371-61.495,52.343-101.943l0.01-17.371 c0-6.548-0.605-13.276-1.824-19.905l-0.705-3.948h-9.348l21.429-51.338V0.09z M206.033,19.138V9.614h9.524v9.524H206.033z M189.067,85.714h-18.062l-8.657-19.048h17.929L189.067,85.714z M147.219,16.119l18.929,8.11l-4.467,2.19l14.2,30.724h-17.862 l-11.605-25.471l-4.262,2.152L147.219,16.119z M160.543,85.715h-21.176v-9.433c0-5.252,4.271-9.614,9.524-9.614h2.995v-0.001 L160.543,85.715z M141.843,44.652l5.776,12.71c-9.905,0.667-17.776,8.848-17.776,18.919v9.433h-19.048v-7.176 c9.529-6.386,15.995-16.352,18.176-27.452L141.843,44.652z M53.653,42.948c0-18.376,14.957-33.333,33.333-33.333 c18.376,0,33.333,14.957,33.333,33.333c0,11.829-6.39,22.881-16.671,28.838l-2.376,1.371v12.557h-9.524V56.352 c5.529-1.971,9.524-7.21,9.524-13.41c0-7.876-6.41-14.286-14.286-14.286c-7.876,0-14.286,6.411-14.286,14.287 c0,6.2,3.995,11.438,9.524,13.41v29.362H72.7V73.157l-2.376-1.376C60.043,65.824,53.653,54.776,53.653,42.948z M86.986,47.71 c-2.629,0-4.762-2.139-4.762-4.762c0-2.624,2.133-4.762,4.762-4.762c2.629,0,4.762,2.138,4.762,4.762 C91.748,45.571,89.615,47.71,86.986,47.71z M54.014,214.286v-35.401l-24.267-5.543l25.943-46.343 c3.657,10.086,8.838,19.638,15.31,28.306c14.072,18.505,34.173,31.805,56.961,37.405c-6.771,2.248-13.657,4.171-20.629,5.81 l3.324,9.071c14.376-3.581,28.629-9.048,42.1-16.419l4.781,4.781l9.247-9.248l-11.305-11.305l-9.248,9.248l4.753,4.752 c-11.896,6.405-24.457,11.295-37.343,14.524c-1.724-4.771-3.362-9.581-4.957-14.419c17.1-4.686,33.162-13.11,46.619-24.986 l8.71-7.748l-6.153-8.838c-5.905-8.438-10.505-17.848-13.629-27.819l-1.781-5.81h-4.738l-3.221,17.429 c-3.971,21.495-15.948,40.552-33.214,54.076c-13.176-1.8-26.01-5.714-37.976-11.71c-18.495-9.324-33.286-23.829-43.219-41.267 l0.038-0.062l-1.667-2.9c-4.771-8.438-8.381-17.457-10.705-26.857c-2.124-8.971-2.886-18.152-2.29-27.181l1.848-13.571h21.419 v19.048c0,23.81,19.048,42.857,42.857,42.857s42.857-19.048,42.857-42.857v-28.571h78.933c0.667,4.438,1.009,8.905,1.014,13.371 l-0.01,17.371c-0.038,36.476-17.657,70.81-47.2,91.724l-3.329,2.371v55.629H95.695v-42.857H54.014z M196.51,204.762v57.143 H104.1v-57.143H196.51z M148.338,156.871c-0.086,0.048-0.186,0.062-0.276,0.114c-11.2-3.924-21.543-9.571-30.648-16.819 l1.2-9.771h59.676C171.071,141.429,160.91,149.552,148.338,156.871z M229.843,39.957l0.037-0.086l-0.067-0.019l-18.49,44.324 c-1.581-2.438-2.719-5.086-3.371-7.81l21.867-18.829L229.843,39.957z"></path>
                              <path d="M96.51,123.81c7.876,0,14.286,4.762,14.286,14.286c0,9.524-6.41,14.286-14.286,14.286 c-7.876,0-14.286-4.762-14.286-14.286S88.634,123.81,96.51,123.81z M96.51,138.096c4.757,0,4.762-9.524,0-9.524 C91.748,128.571,91.748,138.096,96.51,138.096z"></path>
                            </g>
                          </g>
                        </g>
                      </svg>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>{" "}
    </div>
  );
};

export default Faq;
